var te = Object.defineProperty, ie = Object.defineProperties;
var ne = Object.getOwnPropertyDescriptors;
var v = Object.getOwnPropertySymbols;
var I = Object.prototype.hasOwnProperty, P = Object.prototype.propertyIsEnumerable;
var E = (r, t, e) => t in r ? te(r, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[t] = e, f = (r, t) => {
  for (var e in t || (t = {}))
    I.call(t, e) && E(r, e, t[e]);
  if (v)
    for (var e of v(t))
      P.call(t, e) && E(r, e, t[e]);
  return r;
}, y = (r, t) => ie(r, ne(t));
var k = (r, t) => {
  var e = {};
  for (var i in r)
    I.call(r, i) && t.indexOf(i) < 0 && (e[i] = r[i]);
  if (r != null && v)
    for (var i of v(r))
      t.indexOf(i) < 0 && P.call(r, i) && (e[i] = r[i]);
  return e;
};
var g = (r, t, e) => E(r, typeof t != "symbol" ? t + "" : t, e);
import { jsxs as c, jsx as o, Fragment as re } from "react/jsx-runtime";
import { bD as se, l as O, bE as G, I as B, bF as oe, bG as ae, bH as le, bz as de, bI as ue, W as ce, b9 as pe, T as C, bJ as he, bK as me, b8 as fe, bc as ge, bd as be, bL as Se, be as ye, s as H, bM as W, bN as we, e as V, B as Ce, bO as Ne, b1 as _e, H as ve, a5 as xe, bP as Ee, bQ as L, bR as F, bS as U, E as ke, F as Le, S as Te, bv as Ae, bw as Be } from "./App-ChpItgs-.js";
import { List as T, Set as Re } from "immutable";
import { PureComponent as j, memo as Me, useRef as De, useEffect as Ie, Component as R } from "react";
import Y from "hammerjs";
import { connect as K } from "react-redux";
import { getShortId as Pe } from "@mapado/js-component";
import { TOAST_TYPE as b, MpdSingleSelect as Oe, MpdIcon as Ve, useMpdToast as Fe, dropdown as Ue } from "@mapado/makeup";
import { Seat as Ye, assertRelationIsString as Xe, assertRelationIsDefined as $e, SeatConfigBlock as ze, SEAT_TYPE as q, SeatGroup as Ge } from "@mapado/ticketing-js-sdk";
function He({ children: r }) {
  var d;
  const { initialTransform: t, currentTransform: e, relativeTransform: i } = se(), n = O(G), s = O(B), l = oe(
    n != null ? n : T(),
    (d = s == null ? void 0 : s.seatConfigBlockList) != null ? d : []
  );
  return /* @__PURE__ */ c("div", { style: { display: "flex", flexDirection: "column", gap: "10px" }, children: [
    /* @__PURE__ */ o("div", { style: { marginBottom: "10px" }, children: /* @__PURE__ */ c("div", { style: { marginTop: "10px", fontSize: "12px" }, children: [
      /* @__PURE__ */ o("strong", { children: "Debug Info:" }),
      /* @__PURE__ */ c("div", { children: [
        "Initial Transform: ",
        t || "Non défini"
      ] }),
      /* @__PURE__ */ c("div", { children: [
        "Current Transform: ",
        e || "Non défini"
      ] }),
      /* @__PURE__ */ c("div", { children: [
        "Relative - Scale: ",
        i.scaleX.toFixed(2),
        " /",
        " ",
        i.scaleY.toFixed(2),
        ", Translate X:",
        " ",
        i.translateX.toFixed(2),
        ", Y:",
        " ",
        i.translateY.toFixed(2)
      ] }),
      /* @__PURE__ */ c("div", { children: [
        "ViewBox: ",
        l.minX.toFixed(0),
        ", ",
        l.minY.toFixed(0),
        ",",
        " ",
        l.width.toFixed(0),
        ", ",
        l.height.toFixed(0)
      ] })
    ] }) }),
    r
  ] });
}
function Et() {
  const r = ae();
  return le() === null ? null : /* @__PURE__ */ o(de, { children: ({ relativeTransform: e }) => /* @__PURE__ */ o(He, { children: /* @__PURE__ */ o(
    ue,
    {
      pdfInfo: r,
      withPreview: !0,
      relativeTransform: e,
      selectedView: ce.SeatGroup
    }
  ) }) });
}
const A = [
  "info",
  "x",
  "y",
  "z",
  "width",
  "height",
  "fontSize",
  "seatConfig"
];
function We(r) {
  return (t, e) => {
    const i = e(), n = B(i);
    $e(n, "seatConfig");
    const s = new ze({
      "@id": null,
      "@type": "SeatConfigBlock",
      x: 0,
      y: 0,
      info: "",
      seatConfig: n["@id"]
    });
    return C.getDefaultSerializerSdk().getRepository("seatConfigBlock").create(s, { fields: A }).then((d) => (r({
      title: "Le SeatConfigBlock a été créé avec succès.",
      type: b.SUCCESS
    }), t({
      type: ye,
      seatConfigBlock: d.toJSON()
    }))).catch((d) => {
      console.error(d), r({
        title: "Une erreur est survenue pendant la création du SeatConfigBlock.",
        type: b.ERROR
      });
    });
  };
}
function je(r) {
  return {
    type: be,
    index: r
  };
}
function Ke(r, t, e, i = !0) {
  return (n) => {
    if (n({
      type: ge,
      id: r,
      info: t
    }), !i)
      return;
    const s = C.getDefaultSerializerSdk();
    s.getRepository("seatConfigBlock").find(r, { fields: A }).then(
      (l) => s.getRepository("seatConfigBlock").update(l.set("info", t), {
        fields: A
      }).then(() => {
        e({
          title: "Le SeatConfigBlock a été modifié avec succès.",
          type: b.SUCCESS
        });
      }).catch((d) => {
        console.error(d), e({
          title: "Une erreur est survenue pendant la modification du SeatConfigBlock.",
          type: b.ERROR
        });
      })
    );
  };
}
function qe(r) {
  return (t) => {
    const e = r ? "update" : "create";
    return C.getDefaultSerializerSdk().getRepository("seatGroup")[e](r, {
      fields: ["seatConfig"]
    }).then((i) => {
      const n = i.get("seatConfig");
      Xe(n, "seatConfig");
      const s = n.replace("/v1/seat_configs/", "");
      return t(Se(s, !0, !0));
    });
  };
}
function Je(r, t) {
  return (e) => {
    e({
      type: pe,
      seatList: r
    });
    const i = r.map((n) => {
      const s = new Ye(f({}, n));
      return C.getDefaultSerializerSdk().getRepository("seat").update(s, {
        fields: ["@id"]
      });
    });
    return Promise.all(i).catch((n) => {
      console.error(n), t();
    });
  };
}
function Qe(r, t, e, i, n) {
  const s = me(t), l = he(e);
  return (d) => (d({
    type: fe,
    seatId: `/v1/seats/${r}`,
    x: s,
    y: l
  }), C.getDefaultSerializerSdk().getRepository("seat").find(r, {
    fields: [
      "@id",
      "coordinates",
      "label",
      "seatNumber",
      "row",
      "seatGroup",
      "position",
      "visible",
      "stockContingent"
    ]
  }).then((a) => {
    const u = a.setIn(["coordinates", "Y"], l).setIn(["coordinates", "X"], s);
    return C.getDefaultSerializerSdk().getRepository("seat").update(u, {
      fields: ["@id"]
    }).then(() => {
      i({
        title: "La position du siège a été mise à jour avec succès.",
        type: b.SUCCESS
      });
    });
  }).catch((a) => {
    console.error(a), n(), i({
      title: "Erreur lors du déplacement du siège.",
      type: b.ERROR
    });
  }));
}
function N(r) {
  var t;
  return (t = r.row) != null ? t : "";
}
function w(r) {
  var t;
  return (t = r.seatNumber) != null ? t : "";
}
function X(r, t) {
  const { newRow: e, newSeat: i } = t, n = e || N(r), s = i || w(r);
  return `${n}${s}`;
}
function Ze({ onChange: r, value: t }) {
  const { t: e } = V(), { t: i } = V("admin");
  return /* @__PURE__ */ c("div", { children: [
    i("order.origin", { name: "normal" }),
    /* @__PURE__ */ o(
      Oe,
      {
        label: "Type de siège",
        value: t,
        options: Object.values(q).map(
          (n) => ({
            label: e("seat_type", { name: n }),
            value: n
          })
        ),
        placeholder: "Valeurs multiples",
        onChange: r
      }
    )
  ] });
}
class J extends j {
  constructor(t) {
    super(t), this.state = {
      newRow: void 0,
      newSeat: void 0,
      newType: void 0
    }, this.editSeatInfo = this.editSeatInfo.bind(this), this.saveSeats = this.saveSeats.bind(this), this.selectRow = this.selectRow.bind(this), this.selectColumn = this.selectColumn.bind(this);
  }
  editSeatInfo(t, e) {
    this.setState((i) => y(f({}, i), {
      [t]: e
    }));
  }
  saveSeats() {
    const { newRow: t, newSeat: e, newType: i } = this.state, { selectedSeatList: n, updateSeatList: s, onError: l } = this.props;
    if (!n || n.size > 1 && // eslint-disable-next-line no-alert
    !window.confirm(
      `${n.size} sèges seront modifés. Continuer ?`
    ) || typeof t == "undefined" && typeof e == "undefined" && typeof i == "undefined")
      return;
    const d = {};
    typeof t != "undefined" && (d.row = t), typeof e != "undefined" && (d.seatNumber = e), typeof i != "undefined" && (d.type = i), s(
      n.map((a) => y(f(y(f({}, a), {
        // @ts-expect-error -- should be null, but the API but does trigger an error actually
        info: {}
      }), d), {
        label: X(a, this.state)
      })),
      l
    ), this.setState({
      newRow: void 0,
      newSeat: void 0,
      newType: void 0
    });
  }
  selectRow(t) {
    t.preventDefault();
    const { seatList: e, selectedSeatList: i, selectBatchOfSeats: n } = this.props, s = i == null ? void 0 : i.first();
    if (!e || !s)
      return;
    const l = N(s), d = e.filter((a) => N(a) === l).map((a) => Number(a["@id"].replace("/v1/seats/", ""))).toSet();
    n(d);
  }
  selectColumn(t) {
    t.preventDefault();
    const { seatList: e, selectedSeatList: i, selectBatchOfSeats: n } = this.props, s = i == null ? void 0 : i.first();
    if (!e || !s)
      return;
    const l = w(s), d = e.filter((a) => w(a) === l).map((a) => Number(a["@id"].replace("/v1/seats/", ""))).toSet();
    n(d);
  }
  render() {
    const { selectedSeatList: t } = this.props, { newRow: e, newSeat: i, newType: n } = this.state;
    if (!t || t.size === 0)
      return null;
    const s = t.first();
    if (!s)
      throw new Error("Seat list should not be empty. This should not happen");
    const l = t.groupBy(N).size === 1, d = t.groupBy(w).size === 1, a = t.size === 1;
    return /* @__PURE__ */ c("div", { className: "p3", children: [
      /* @__PURE__ */ o("div", { children: /* @__PURE__ */ c("strong", { children: [
        t.size,
        " sièges sélectionnés"
      ] }) }),
      /* @__PURE__ */ c("div", { className: "mt2", children: [
        /* @__PURE__ */ o("div", { children: /* @__PURE__ */ o("strong", { children: "Informations de sièges" }) }),
        /* @__PURE__ */ c("div", { className: "form-group", children: [
          /* @__PURE__ */ o(
            "input",
            {
              type: "text",
              value: e || (l ? N(s) : ""),
              onChange: (u) => this.editSeatInfo("newRow", u.target.value),
              className: "form-control",
              id: "input-seat-row",
              placeholder: "Valeurs multiples"
            }
          ),
          /* @__PURE__ */ o("label", { htmlFor: "input-seat-row", children: "Rangée" }),
          a && /* @__PURE__ */ o("a", { href: "#allRow", onClick: this.selectRow, children: "Toute la rangée" })
        ] }),
        /* @__PURE__ */ c("div", { className: "form-group", children: [
          /* @__PURE__ */ o(
            "input",
            {
              type: "text",
              value: i || (d ? w(s) : ""),
              onChange: (u) => this.editSeatInfo("newSeat", u.target.value),
              className: "form-control",
              id: "input-seat-number",
              placeholder: "Valeurs multiples"
            }
          ),
          /* @__PURE__ */ o("label", { htmlFor: "input-seat-number", children: "Numéro de place" }),
          a && /* @__PURE__ */ o("a", { href: "#allColumn", onClick: this.selectColumn, children: "Toute la colonne" })
        ] }),
        a && /* @__PURE__ */ c("div", { className: "form-group", children: [
          /* @__PURE__ */ o(
            "input",
            {
              type: "text",
              readOnly: !0,
              value: X(s, this.state),
              className: "form-control",
              id: "input-seat-label"
            }
          ),
          /* @__PURE__ */ o("label", { htmlFor: "input-seat-label", children: "Libellé" })
        ] }),
        /* @__PURE__ */ c("div", { className: "form-group", children: [
          /* @__PURE__ */ o(
            Ze,
            {
              value: n ? { label: n, value: n } : { label: s.type, value: s.type },
              onChange: (u) => {
                var p;
                return this.editSeatInfo("newType", (p = u == null ? void 0 : u.value) != null ? p : q.NORMAL);
              }
            }
          ),
          /* @__PURE__ */ o(
            "input",
            {
              type: "text",
              value: i || (d ? w(s) : ""),
              onChange: (u) => this.editSeatInfo("newSeat", u.target.value),
              className: "form-control",
              id: "input-seat-number",
              placeholder: "Valeurs multiples"
            }
          ),
          /* @__PURE__ */ o("label", { htmlFor: "input-seat-number", children: "Numéro de place" }),
          a && /* @__PURE__ */ o("a", { href: "#allColumn", onClick: this.selectColumn, children: "Toute la colonne" })
        ] }),
        (typeof e != "undefined" || typeof i != "undefined" || typeof n != "undefined") && /* @__PURE__ */ o("div", { className: "form-group txtcenter", children: /* @__PURE__ */ o(
          "button",
          {
            type: "button",
            className: "mpd-btn mpd-btn--primary",
            onClick: this.saveSeats,
            children: "Enregistrer les modifications"
          }
        ) })
      ] }),
      /* @__PURE__ */ o("hr", { className: "mt3" })
    ] });
  }
}
g(J, "defaultProps", {
  selectedSeatList: void 0
});
const et = (r) => {
  const t = B(r), e = W(r), i = we(r);
  return {
    selectedSeatList: e == null ? void 0 : e.map((n) => i.get(`/v1/seats/${n}`)).filter((n) => typeof n != "undefined").toList(),
    seatList: G(r),
    seatConfig: t
  };
}, tt = {
  updateSeatList: Je,
  selectBatchOfSeats: H
}, it = K(
  et,
  tt
)(J), Q = Me((e) => {
  var i = e, { color: r } = i, t = k(i, ["color"]);
  return /* @__PURE__ */ o(
    Ce,
    y(f({}, t), {
      icon: "seat-filled",
      fill: r,
      displaySeatLabel: !0
    })
  );
});
Q.displayName = "PlanEditorSeat";
function nt(i) {
  var n = i, {
    registerNode: r,
    unRegisterNode: t
  } = n, e = k(n, [
    "registerNode",
    "unRegisterNode"
  ]);
  const s = De(null);
  return Ie(() => {
    const { current: l } = s;
    return l && r(l), () => {
      l && t(l);
    };
  }, [s, r, t]), /* @__PURE__ */ o("g", { className: "mpd-seating__editor-element", children: /* @__PURE__ */ o(Ne, f({ ref: s }, e)) });
}
const Z = (r) => {
  switch (r.toLowerCase()) {
    case "line":
      return "Ligne";
    case "rect":
      return "Rectangle";
    case "circle":
      return "Cercle";
    case "text":
      return "Texte";
    default:
      return "";
  }
};
function rt(r, t, e = null) {
  if (e !== null)
    return e(
      r
      /* , attribute */
    );
  if (typeof t == "undefined")
    throw new Error(
      "attribute should be defined if there is no getValueFunction"
    );
  return r.getAttribute(t);
}
const _ = {
  rect: [
    {
      label: "Largeur",
      type: "number",
      attribute: "width",
      attributeListToUpdate: ["width"],
      defaultValue: 50,
      id: "width"
    },
    {
      label: "Hauteur",
      type: "number",
      attribute: "height",
      attributeListToUpdate: ["height"],
      defaultValue: 50,
      id: "height"
    },
    {
      label: "X",
      type: "number",
      attribute: "x",
      attributeListToUpdate: ["x", "data-originalX"],
      defaultValue: 0,
      id: "x"
    },
    {
      label: "Y",
      type: "number",
      attribute: "y",
      attributeListToUpdate: ["y", "data-originalY"],
      defaultValue: 0,
      id: "y"
    },
    {
      label: "Couleur bordure",
      type: "color",
      attribute: "stroke",
      attributeListToUpdate: ["stroke"],
      defaultValue: "#808080",
      id: "color"
    },
    {
      label: "Epaisseur bordure",
      type: "number",
      attribute: "stroke-width",
      attributeListToUpdate: ["stroke-width"],
      defaultValue: 1,
      id: "stroke-width",
      getValueFunction: (r) => {
        const t = r.getAttribute("stroke-width");
        return t === null ? 1 : t;
      }
    },
    {
      label: "Couleur de fond",
      type: "color",
      attribute: "fill",
      attributeListToUpdate: ["fill"],
      defaultValue: "#cdcdcd",
      id: "fill"
    },
    {
      label: "Rotation",
      type: "number",
      id: "rotation",
      getValueFunction: (r) => {
        var i, n;
        if (!r.getAttribute("transform"))
          return 0;
        const e = (n = (i = r.getAttribute("transform")) == null ? void 0 : i.match(/\d+/g)) == null ? void 0 : n.map(Number);
        return e === null || typeof (e == null ? void 0 : e[0]) == "undefined" ? 0 : e[0];
      },
      setAttributeFunction: (r, t) => {
        var a, u, p, h;
        const e = Number((a = r.getAttribute("x")) == null ? void 0 : a.replace("px", "")), i = Number((u = r.getAttribute("y")) == null ? void 0 : u.replace("px", "")), n = Number((p = r.getAttribute("width")) == null ? void 0 : p.replace("px", "")), s = Number((h = r.getAttribute("height")) == null ? void 0 : h.replace("px", "")), l = e + n / 2, d = i + s / 2;
        r.setAttribute(
          "transform",
          `rotate(${t || "0"} ${l} ${d})`
        );
      }
    },
    {
      label: "Arrondi X",
      type: "number",
      attribute: "rx",
      attributeListToUpdate: ["rx", "data-originalRX"],
      defaultValue: "3",
      id: "rx"
    },
    {
      label: "Arrondi Y",
      type: "number",
      attribute: "ry",
      attributeListToUpdate: ["ry", "data-originalRY"],
      defaultValue: "3",
      id: "ry"
    }
  ],
  circle: [
    {
      label: "Rayon",
      type: "number",
      attribute: "r",
      attributeListToUpdate: ["r"],
      defaultValue: 30,
      id: "r"
    },
    {
      label: "X",
      type: "number",
      attribute: "cx",
      attributeListToUpdate: ["cx", "data-originalCX"],
      defaultValue: 0,
      id: "cx"
    },
    {
      label: "Y",
      type: "number",
      attribute: "cy",
      attributeListToUpdate: ["cy", "data-originalCY"],
      defaultValue: 0,
      id: "cy"
    },
    {
      label: "Couleur bordure",
      type: "string",
      attribute: "stroke",
      attributeListToUpdate: ["stroke"],
      defaultValue: "#808080",
      id: "stroke"
    },
    {
      label: "Epaisseur bordure",
      type: "number",
      attribute: "stroke-width",
      id: "stroke-width",
      attributeListToUpdate: ["stroke-width"],
      defaultValue: 1,
      getValueFunction: (r) => {
        const t = r.getAttribute("stroke-width");
        return t === null ? 1 : t;
      }
    },
    {
      label: "Couleur de fond",
      type: "string",
      attribute: "fill",
      attributeListToUpdate: ["fill"],
      defaultValue: "#cdcdcd",
      id: "fill"
    }
  ],
  text: [
    {
      label: "X",
      type: "number",
      attribute: "x",
      attributeListToUpdate: ["x", "data-originalX"],
      defaultValue: 0,
      id: "x"
    },
    {
      label: "Y",
      type: "number",
      attribute: "y",
      attributeListToUpdate: ["y", "data-originalY"],
      defaultValue: 0,
      id: "y"
    },
    {
      label: "Texte",
      type: "string",
      id: "text",
      getValueFunction: (r) => r.innerHTML,
      setAttributeFunction: (r, t) => {
        r.innerHTML = t != null ? t : "";
      },
      defaultValue: ""
    },
    {
      label: "Taille",
      type: "number",
      attribute: "font-size",
      attributeListToUpdate: ["font-size"],
      defaultValue: 14,
      id: "font-size",
      getValueFunction: (r) => {
        const t = r.getAttribute("font-size");
        return t ? t.replace("px", "") : 14;
      }
    },
    {
      label: "Rotation",
      type: "number",
      id: "rotation",
      getValueFunction: (r) => {
        var i, n;
        if (!r.getAttribute("transform"))
          return 0;
        const e = (n = (i = r.getAttribute("transform")) == null ? void 0 : i.match(/\d+/g)) == null ? void 0 : n.map(Number);
        return e === null || typeof (e == null ? void 0 : e[0]) == "undefined" ? 0 : e[0];
      },
      setAttributeFunction: (r, t) => {
        const e = Number(r.getAttribute("x")), i = Number(r.getAttribute("y")), n = e, s = i;
        r.setAttribute(
          "transform",
          `rotate(${t || "0"} ${n} ${s})`
        );
      }
    }
  ],
  line: [
    {
      label: "X1",
      type: "number",
      attribute: "x1",
      attributeListToUpdate: ["x1"],
      defaultValue: 300,
      id: "x1"
    },
    {
      label: "Y1",
      type: "number",
      attribute: "y1",
      attributeListToUpdate: ["y1"],
      defaultValue: -100,
      id: "y1"
    },
    {
      label: "X2",
      type: "number",
      attribute: "x2",
      attributeListToUpdate: ["x2"],
      defaultValue: 0,
      id: "x2"
    },
    {
      label: "Y2",
      type: "number",
      attribute: "y2",
      attributeListToUpdate: ["y2"],
      defaultValue: -100,
      id: "y2"
    },
    {
      label: "Epaisseur",
      type: "number",
      attribute: "stroke-width",
      attributeListToUpdate: ["stroke-width"],
      defaultValue: 25,
      id: "stroke-width",
      getValueFunction: (r) => {
        const t = r.getAttribute("stroke-width");
        return t === null ? 25 : t;
      }
    },
    {
      label: "Couleur",
      type: "string",
      attribute: "stroke",
      attributeListToUpdate: ["stroke"],
      defaultValue: "#808080",
      id: "stroke"
    },
    {
      label: "Rotation",
      type: "number",
      id: "rotation",
      getValueFunction: (r) => {
        var i, n;
        if (!r.getAttribute("transform"))
          return 0;
        const e = (n = (i = r.getAttribute("transform")) == null ? void 0 : i.match(/\d+/g)) == null ? void 0 : n.map(Number);
        return e === null || typeof (e == null ? void 0 : e[0]) == "undefined" ? 0 : e[0];
      },
      setAttributeFunction: (r, t) => {
        r.setAttribute("transform", `rotate(${t || "0"} 0 0)`);
      }
    }
  ]
};
function st() {
  return Math.random().toString(36).substring(2, 10);
}
function ot({
  changeNodeAttribute: r,
  node: t,
  label: e,
  type: i,
  value: n = null,
  attributeListToUpdate: s = [],
  setAttributeFunction: l = null,
  id: d
}) {
  const a = `${st()}-${d}`;
  if (i === "number") {
    let u;
    return n && (typeof n == "string" ? u = parseFloat(n) : u = n), /* @__PURE__ */ c("div", { className: "form-group mpd-seating__editor__property-form", children: [
      /* @__PURE__ */ o(
        "input",
        {
          className: "form-control mpd-seating__editor__input mpd-seating__editor__input--number",
          type: "number",
          value: u != null ? u : "",
          onChange: (p) => r(
            t,
            parseFloat(p.target.value),
            s,
            l
          ),
          placeholder: e,
          id: a
        }
      ),
      /* @__PURE__ */ o(
        "label",
        {
          className: "mpd-seating__editor__property-label",
          htmlFor: a,
          children: e
        }
      )
    ] });
  }
  if (i === "string" || i === "color") {
    let u = "text";
    return i === "color" && (u = "color"), /* @__PURE__ */ c("div", { className: "form-group mpd-seating__editor__property-form", children: [
      /* @__PURE__ */ o(
        "input",
        {
          className: "form-control mpd-seating__editor__input mpd-seating__editor__input--string",
          type: u,
          value: n != null ? n : "",
          onChange: (p) => r(
            t,
            p.target.value,
            s,
            l
          ),
          placeholder: e,
          id: a
        }
      ),
      /* @__PURE__ */ o(
        "label",
        {
          className: "mpd-seating__editor__property-label",
          htmlFor: a,
          children: e
        }
      )
    ] });
  }
  return null;
}
class at extends R {
  constructor(e) {
    super(e);
    // eslint-disable-next-line react/sort-comp
    g(this, "mouseX");
    g(this, "mouseY");
    this.deleteCurrentNode = this.deleteCurrentNode.bind(this), this.duplicateCurrentNode = this.duplicateCurrentNode.bind(this), this.onMouseDown = this.onMouseDown.bind(this), this.onWindowMouseUp = this.onWindowMouseUp.bind(this), this.onWindowMouseMove = this.onWindowMouseMove.bind(this), this.state = {
      originalPosition: null
    }, this.mouseX = null, this.mouseY = null;
  }
  componentWillUnmount() {
    window.removeEventListener("mouseup", this.onWindowMouseUp), window.removeEventListener("mousemove", this.onWindowMouseMove);
  }
  onMouseDown(e) {
    this.mouseX = e.clientX, this.mouseY = e.clientY;
    const { node: i } = this.props;
    window.addEventListener("mouseup", this.onWindowMouseUp), window.addEventListener("mousemove", this.onWindowMouseMove), document.body.classList.add("mpd-seating--no-select");
    let n;
    i.tagName.toLowerCase() === "line" ? n = {
      x1: i.getAttribute("x1"),
      x2: i.getAttribute("x2"),
      y1: i.getAttribute("y1"),
      y2: i.getAttribute("y2")
    } : i.tagName.toLowerCase() === "circle" ? n = {
      cx: i.getAttribute("cx"),
      cy: i.getAttribute("cy")
    } : n = {
      x: i.getAttribute("x"),
      y: i.getAttribute("y")
    }, this.setState({
      originalPosition: n
    });
  }
  onWindowMouseUp(e) {
    document.body.classList.remove("mpd-seating--no-select"), window.removeEventListener("mouseup", this.onWindowMouseUp), window.removeEventListener("mousemove", this.onWindowMouseMove), this.setState({
      originalPosition: null
    }), this.mouseX = e.clientX, this.mouseY = e.clientY, this.props.forceRerender();
  }
  onWindowMouseMove(e) {
    var u, p;
    const { node: i } = this.props, { originalPosition: n } = this.state, s = e.clientX, l = e.clientY, d = s - ((u = this.mouseX) != null ? u : 0), a = l - ((p = this.mouseY) != null ? p : 0);
    window.requestAnimationFrame(() => {
      if (n !== null)
        if (i.tagName.toLowerCase() === "line") {
          const { x1: h, y1: m, x2: S, y2: x } = n;
          i.setAttribute("x1", `${parseFloat(h) + d}px`), i.setAttribute("y1", `${parseFloat(m) + a}px`), i.setAttribute("x2", `${parseFloat(S) + d}px`), i.setAttribute("y2", `${parseFloat(x) + a}px`);
        } else if (i.tagName.toLowerCase() === "circle") {
          const { cx: h, cy: m } = n;
          i.setAttribute("cx", `${parseFloat(h) + d}px`), i.setAttribute("cy", `${parseFloat(m) + a}px`);
        } else {
          const { x: h, y: m } = n;
          i.setAttribute("x", `${parseFloat(h) + d}px`), i.setAttribute("y", `${parseFloat(m) + a}px`);
        }
    });
  }
  deleteCurrentNode(e) {
    e.preventDefault(), this.props.deleteNode(this.props.node);
  }
  duplicateCurrentNode(e) {
    e.preventDefault();
    const { duplicateNode: i, index: n, node: s } = this.props;
    i(s, n);
  }
  render() {
    const { changeNodeAttribute: e, isLast: i, node: n, onMouseEnter: s, onMouseLeave: l } = this.props, { originalPosition: d } = this.state, a = n.tagName.toLowerCase();
    if (a !== "line" && a !== "circle" && a !== "rect" && a !== "text")
      throw new Error("tagName must be line, circle, rect or text");
    const u = _[a], p = d ? "mpd-seating__editor__property-list--disabled" : "";
    return /* @__PURE__ */ c(
      "div",
      {
        onMouseEnter: () => s(n),
        onMouseLeave: () => l(n),
        className: "mpd-seating__editor__tag",
        children: [
          /* @__PURE__ */ c("div", { className: "mpd-seating__editor__tagname", children: [
            /* @__PURE__ */ o("label", { children: Z(n.tagName) }),
            /* @__PURE__ */ o(
              "span",
              {
                className: "mpd-seating__editor__move-anchor",
                onMouseDown: this.onMouseDown,
                children: "#"
              }
            )
          ] }),
          /* @__PURE__ */ o("div", { className: `mpd-seating__editor__property-list ${p}`, children: u.map((h) => {
            var S;
            const m = (S = rt(
              n,
              h.attribute,
              h.getValueFunction
            )) != null ? S : "";
            return /* @__PURE__ */ o(
              ot,
              f({
                changeNodeAttribute: e,
                node: n,
                value: typeof m == "string" ? m : m.toString()
              }, h),
              h.label
            );
          }) }),
          /* @__PURE__ */ o(
            "button",
            {
              type: "button",
              className: "block w100 txtcenter mpd-btn mpd-btn--secondary mpd-btn--small",
              onClick: this.duplicateCurrentNode,
              children: "Dupliquer"
            }
          ),
          /* @__PURE__ */ o(
            "button",
            {
              type: "button",
              className: "block w100 txtcenter mpd-btn mpd-btn--secondary mpd-btn--small",
              onClick: this.deleteCurrentNode,
              children: "Supprimer"
            }
          ),
          !i && /* @__PURE__ */ o("hr", {})
        ]
      }
    );
  }
}
function $({
  element: r
}) {
  return (
    // eslint-disable-next-line prefer-spread
    [].concat.apply([], r.childNodes).filter(
      (t) => typeof t.tagName != "undefined" && Object.keys(_).indexOf(t.tagName.toLowerCase()) >= 0
    )
  );
}
class lt extends R {
  constructor(t) {
    super(t);
    const e = $(t);
    this.state = {
      isAddingElement: e.length === 0
    }, this.onMouseEnterHandler = this.onMouseEnterHandler.bind(this), this.onMouseLeaveHandler = this.onMouseLeaveHandler.bind(this), this.addElement = this.addElement.bind(this), this.deleteCurrentElement = this.deleteCurrentElement.bind(this), this.onSelectElementTypeToAdd = this.onSelectElementTypeToAdd.bind(this), this.updateCurrentElement = this.updateCurrentElement.bind(this), this.duplicateNode = this.duplicateNode.bind(this);
  }
  onSelectElementTypeToAdd(t) {
    t.preventDefault();
    const { addTagToElement: e, element: i } = this.props, { value: n } = t.target;
    Object.keys(_).indexOf(n) >= 0 && e(i, n), this.setState({
      isAddingElement: !1
    });
  }
  onMouseEnterHandler(t) {
    this.props.setSelectedElement(t, !0);
  }
  onMouseLeaveHandler(t) {
    this.props.setSelectedElement(t, !1);
  }
  deleteCurrentElement(t) {
    t.preventDefault();
    const { removeSeatConfigBlock: e, index: i } = this.props;
    e(i);
  }
  addElement(t) {
    t.preventDefault(), this.setState({
      isAddingElement: !0
    });
  }
  updateCurrentElement() {
    const { toast: t, element: e, updateSeatConfigBlockInfo: i } = this.props, n = e.getAttribute("id");
    if (!n) {
      t({ title: "No id found on this element", type: b.ERROR });
      return;
    }
    i(n, e.innerHTML, t);
  }
  duplicateNode(t, e) {
    this.props.duplicateNode(t, e, this.props.element);
  }
  render() {
    const { changeNodeAttribute: t, deleteNode: e, element: i, forceRerender: n, isLast: s } = this.props, l = i.getAttribute("id");
    if (!l)
      throw new Error("element should have an id");
    const { isAddingElement: d } = this.state, a = $(this.props), u = l.startsWith("/v1/seat_config_blocks/");
    return /* @__PURE__ */ c("div", { children: [
      /* @__PURE__ */ o("div", { className: "mpd-block mpd-block-top", children: /* @__PURE__ */ c("div", { className: "mpd-block-content mpd-dropDown mpd-dropDown--keepOpen", children: [
        /* @__PURE__ */ c(
          "button",
          {
            type: "button",
            className: "mpd-btn mpd-btn--link mpd-btn--no-padding mpd-dropDown-link block",
            children: [
              /* @__PURE__ */ c("h3", { children: [
                u && /* @__PURE__ */ c("span", { children: [
                  "seat_config_block #",
                  l.replace("/v1/seat_config_blocks/", "")
                ] }),
                !u && /* @__PURE__ */ o("span", { children: "Nouveau seat_config_blick" })
              ] }),
              /* @__PURE__ */ o(Ve, { icon: "arrow-down", height: "20", width: "20" })
            ]
          }
        ),
        /* @__PURE__ */ o("div", { className: "mpd-dropDown-contentWrapper", children: /* @__PURE__ */ c("div", { className: "mpd-dropDown-content", children: [
          /* @__PURE__ */ o("hr", {}),
          /* @__PURE__ */ o("div", { children: a.map((p, h) => /* @__PURE__ */ o(
            at,
            {
              onMouseEnter: this.onMouseEnterHandler,
              onMouseLeave: this.onMouseLeaveHandler,
              node: p,
              changeNodeAttribute: t,
              deleteNode: e,
              duplicateNode: this.duplicateNode,
              index: h,
              forceRerender: n,
              isLast: h === a.length - 1
            },
            h
          )) }),
          /* @__PURE__ */ o("hr", {}),
          !d && /* @__PURE__ */ o("div", { children: /* @__PURE__ */ o(
            "button",
            {
              type: "button",
              onClick: this.addElement,
              className: "mpd-btn mpd-btn--primary block txtcenter",
              children: "+ Créer un élément"
            }
          ) }),
          d && /* @__PURE__ */ c("div", { className: "form-group", children: [
            /* @__PURE__ */ c(
              "select",
              {
                id: "plan-editor-new-element-type",
                defaultValue: "",
                onChange: this.onSelectElementTypeToAdd,
                className: "form-control",
                children: [
                  /* @__PURE__ */ o("option", { value: "" }),
                  Object.keys(_).map((p) => /* @__PURE__ */ o("option", { value: p, children: Z(p) }, p))
                ]
              }
            ),
            /* @__PURE__ */ o("label", { htmlFor: "plan-editor-new-element-type", children: "Type du nouvel élément" })
          ] }),
          /* @__PURE__ */ o("hr", {}),
          /* @__PURE__ */ o("div", { className: "mt2 mb2", children: /* @__PURE__ */ o(
            "button",
            {
              type: "button",
              className: "block txtcenter w100 mpd-btn mpd-btn--primary",
              onClick: this.updateCurrentElement,
              children: "Sauvegarder"
            }
          ) }),
          /* @__PURE__ */ o("div", { className: "mt2 mb2", children: /* @__PURE__ */ o(
            "button",
            {
              type: "button",
              className: "block txtcenter mpd-btn mpd-btn--secondary w100",
              onClick: this.deleteCurrentElement,
              children: "Supprimer"
            }
          ) })
        ] }) })
      ] }) }),
      !s && /* @__PURE__ */ o("hr", {})
    ] });
  }
}
function z(r, t, e) {
  [
    "width",
    "height",
    "stroke-width",
    "data-originalX",
    "font-size",
    "data-originalY"
  ].indexOf(t) >= 0 ? r.setAttribute(t, `${e}px`) : typeof e == "undefined" ? r.setAttribute(t, "") : r.setAttribute(
    t,
    typeof e == "string" ? e : e.toString()
  );
}
class dt extends R {
  constructor(t) {
    super(t), this.addNewSeatConfigBlock = this.addNewSeatConfigBlock.bind(this), this.addTagToElement = this.addTagToElement.bind(this), this.changeNodeAttribute = this.changeNodeAttribute.bind(this), this.createNewSeatGroup = this.createNewSeatGroup.bind(this), this.deleteNode = this.deleteNode.bind(this), this.duplicateNode = this.duplicateNode.bind(this), this.forceRerender = this.forceRerender.bind(this);
  }
  forceRerender() {
    this.forceUpdate();
  }
  addTagToElement(t, e) {
    const i = document.createElement(e);
    _[e].forEach(
      ({
        attributeListToUpdate: l,
        defaultValue: d,
        setAttributeFunction: a = null
      }) => {
        a !== null ? a(i, d) : l && l.forEach((u) => {
          z(i, u, d);
        });
      }
    ), t.appendChild(i);
    const s = t.getAttribute("id");
    if (!s)
      throw new Error("id is undefined");
    this.props.updateSeatConfigBlockInfo(
      // @ts-expect-error this is an iri here
      s,
      t.innerHTML,
      this.props.toast,
      !1
    );
  }
  changeNodeAttribute(t, e, i, n = null) {
    n !== null ? n(t, e) : i.forEach((s) => {
      z(t, s, e);
    }), this.forceRerender();
  }
  addNewSeatConfigBlock() {
    this.props.addSeatConfigBlock(this.props.toast);
  }
  deleteNode(t) {
    t.remove(), this.forceRerender();
  }
  duplicateNode(t, e, i) {
    const n = t.cloneNode(!0);
    i.appendChild(n);
    const s = i.getAttribute("id");
    if (!s)
      throw new Error("id is undefined");
    this.props.updateSeatConfigBlockInfo(
      // @ts-expect-error this is an iri here
      s,
      i.innerHTML,
      this.props.toast,
      !1
    ), this.forceRerender();
  }
  createNewSeatGroup() {
    const { seatConfig: t, createOrUpdateSeatGroup: e, seatGroupList: i } = this.props, n = i.size, s = new Ge({
      "@id": null,
      "@type": "SeatGroup",
      seatConfig: t["@id"],
      label: `SeatGroup ${n + 1}`
    });
    e(s);
  }
  render() {
    const {
      toast: t,
      children: e,
      registeredElements: i,
      removeSeatConfigBlock: n,
      setSelectedElement: s,
      updateSeatConfigBlockInfo: l
    } = this.props;
    return /* @__PURE__ */ c("div", { className: "mpd-seating__editor__sidebar", children: [
      e ? /* @__PURE__ */ c(re, { children: [
        e,
        /* @__PURE__ */ o("hr", {})
      ] }) : "",
      /* @__PURE__ */ c("div", { className: "mpd-seating__editor__sidebar__seat-config-blocks", children: [
        /* @__PURE__ */ o("h3", { children: "Elements" }),
        i.map((d, a) => /* @__PURE__ */ o(
          lt,
          {
            addTagToElement: this.addTagToElement,
            toast: t,
            changeNodeAttribute: this.changeNodeAttribute,
            element: d,
            index: a,
            setSelectedElement: s,
            deleteNode: this.deleteNode,
            duplicateNode: this.duplicateNode,
            removeSeatConfigBlock: n,
            isLast: a === i.length - 1,
            forceRerender: this.forceRerender,
            updateSeatConfigBlockInfo: l
          },
          d.getAttribute("id")
        )),
        /* @__PURE__ */ o(
          "button",
          {
            type: "button",
            className: "block txtcenter mpd-btn mpd-btn--primary mpd-btn--small",
            onClick: this.addNewSeatConfigBlock,
            children: "+ Ajouter un seat_config_block"
          }
        )
      ] })
    ] });
  }
}
function ut(r, t) {
  t ? r.classList.add("mpd-seating__editor-element--selected") : r.classList.remove("mpd-seating__editor-element--selected");
}
let ct = class extends j {
  constructor(e) {
    super(e);
    g(this, "_ref");
    g(this, "_seatNodeMap");
    g(this, "_seatHammerMap");
    g(this, "_svgDrawer");
    this.state = {
      registeredElements: [],
      isDrawing: !1
    }, this.getSeatConfigBlock = this.getSeatConfigBlock.bind(this), this.init = this.init.bind(this), this.registerNode = this.registerNode.bind(this), this.unRegisterNode = this.unRegisterNode.bind(this), this.setRef = this.setRef.bind(this), this.getMaxPosition = this.getMaxPosition.bind(this), this.handleDrawButtonChange = this.handleDrawButtonChange.bind(this), this.onClickSeat = this.onClickSeat.bind(this), this._ref = null, this._seatNodeMap = {}, this._seatHammerMap = {}, this._svgDrawer = new xe({
      selectBatchOfSeats: this.props.selectBatchOfSeats
    });
  }
  componentDidMount() {
    const { seatConfigId: e } = this.props;
    if (!e)
      throw new Error("No seatConfigId provided");
    this.init(), Ue();
  }
  componentDidUpdate(e) {
    this.state.isDrawing ? (this._svgDrawer.setMode(Ee), this._svgDrawer.handleSelectedSeatIdListChange(
      this.props.selectedSeatIdSet
    )) : this._svgDrawer.setMode(null), e.selectedSeatIdSet.size > 0 && this.props.selectedSeatIdSet.size === 0 && this._svgDrawer.handleSelectedSeatIdListChange(
      this.props.selectedSeatIdSet
    );
  }
  componentWillUnmount() {
    this.props.resetState();
  }
  onClickSeat(e, i, n) {
    const { selectBatchOfSeats: s } = this.props, l = Number(Pe(e["@id"]));
    n && s([l]);
  }
  getMaxPosition() {
    const { seatList: e } = this.props, i = e.map((n) => n.position).toArray();
    return i.length === 0 ? 0 : Math.max(...i);
  }
  setRef(e) {
    this._ref === null && (this._ref = e, this._svgDrawer.init(), e.querySelectorAll(".mpd-seating__seat").forEach((n) => {
      const s = n.getAttribute("id");
      if (!s || !(n instanceof HTMLElement))
        return;
      this._seatNodeMap[s] = n, n.addEventListener("mousedown", L), n.addEventListener("mouseup", F);
      let l = null;
      const d = new Y(n);
      d.get("pan").set({ direction: Y.DIRECTION_ALL }), d.on("panstart", () => {
        var a;
        n.setAttribute(
          "data-start-pan-transform",
          (a = n.getAttribute("transform")) != null ? a : ""
        ), L();
      }), d.on("panend", () => {
        var h;
        const a = n.getAttribute("transform");
        if (!a)
          return;
        const { x: u, y: p } = U(a);
        this.props.updateSeatPosition(s, u, p, this.props.toast, this.init), n.setAttribute(
          "data-start-pan-transform",
          (h = n.getAttribute("transform")) != null ? h : ""
        ), F();
      }), d.on("panleft panright panup pandown", (a) => {
        var M;
        const { deltaX: u, deltaY: p } = a;
        L(), l === null && (l = n.addEventListener(
          "click",
          (D) => {
            D.preventDefault(), D.stopPropagation(), l !== null && n.removeEventListener("click", l);
          }
        ));
        let h = n.getAttribute(
          "data-start-pan-transform"
        );
        if (h || (n.setAttribute(
          "data-start-pan-transform",
          (M = n.getAttribute("transform")) != null ? M : ""
        ), h = n.getAttribute(
          "data-start-pan-transform"
        )), !h)
          return;
        const { x: m, y: S } = U(h), x = m + u, ee = S + p;
        n.setAttribute("transform", `translate(${x}, ${ee})`);
      }), this._seatHammerMap[s] = d;
    }));
  }
  getSeatConfigBlock({ id: e, info: i }) {
    return /* @__PURE__ */ o(
      nt,
      {
        registerNode: this.registerNode,
        unRegisterNode: this.unRegisterNode,
        id: e,
        info: i
      }
    );
  }
  init() {
    const { seatConfigId: e, initSeatingPlanViewer: i } = this.props;
    i(e);
  }
  // eslint-disable-next-line react/sort-comp
  handleDrawButtonChange(e) {
    this.setState({
      isDrawing: e
    });
  }
  registerNode(e) {
    this.setState((i) => {
      const n = i.registeredElements.slice(0);
      return n.push(e), {
        registeredElements: n
      };
    });
  }
  unRegisterNode(e) {
    this.setState((i) => {
      const n = i.registeredElements.slice(0), s = n.findIndex((l) => l === e);
      return s >= 0 ? (n.splice(s, 1), {
        registeredElements: n
      }) : i;
    });
  }
  render() {
    const {
      addSeatConfigBlock: e,
      toast: i,
      createOrUpdateSeatGroup: n,
      removeSeatConfigBlock: s,
      seatConfig: l,
      updateSeatConfigBlockInfo: d,
      seatGroupList: a
    } = this.props, { isDrawing: u, registeredElements: p } = this.state;
    return /* @__PURE__ */ o("div", { className: "mpd-seating__app context-config", id: "mpd-seating__app", children: l && /* @__PURE__ */ c("div", { className: "mpd-seating__app__container", ref: this.setRef, children: [
      /* @__PURE__ */ o("div", { className: "mpd-seating__app__event-svg-wrapper", children: /* @__PURE__ */ o(
        ke,
        {
          SeatElement: Q,
          seatEntityType: "Seat",
          SeatConfigBlockElement: this.getSeatConfigBlock,
          isMovingSeat: !1,
          getSelectableSeatIdSet: (h, m) => m,
          onClickSeat: this.onClickSeat,
          seatConfigBlockList: l.seatConfigBlockList,
          actionButtons: /* @__PURE__ */ o(
            Le,
            {
              isDrawing: u,
              onChange: this.handleDrawButtonChange
            }
          ),
          isPdfDownloadAvailable: !0
        }
      ) }),
      /* @__PURE__ */ o(Te, { children: /* @__PURE__ */ o(
        dt,
        {
          addSeatConfigBlock: e,
          toast: i,
          createOrUpdateSeatGroup: n,
          registeredElements: p,
          removeSeatConfigBlock: s,
          seatConfig: l,
          seatGroupList: a,
          setSelectedElement: ut,
          updateSeatConfigBlockInfo: d,
          children: /* @__PURE__ */ o(it, { onError: this.init })
        }
      ) })
    ] }) });
  }
};
function pt(r) {
  const t = Fe();
  return /* @__PURE__ */ o(ct, y(f({}, r), { toast: t }));
}
const ht = (r) => {
  var t, e, i;
  return {
    seatConfig: r.seating.get("seatConfig"),
    seatList: (t = r.seating.get("seatList")) != null ? t : T(),
    seatGroupList: (e = r.seating.get("seatGroupList")) != null ? e : T(),
    selectedSeatIdSet: (i = W(r)) != null ? i : Re()
  };
}, mt = {
  resetState: ve,
  addSeatConfigBlock: We,
  createOrUpdateSeatGroup: qe,
  initSeatingPlanViewer: _e,
  removeSeatConfigBlock: je,
  updateSeatConfigBlockInfo: Ke,
  updateSeatPosition: Qe,
  selectBatchOfSeats: H
}, ft = K(
  ht,
  mt
)(pt);
function Lt(r) {
  return /* @__PURE__ */ o(Ae, { name: Be.PLAN_EDITOR, children: /* @__PURE__ */ o(ft, f({}, r)) });
}
export {
  Be as CONTEXT_NAMES,
  Et as PdfLiveRendering,
  Lt as PlanEditor,
  le as useRenderingNameContext
};
//# sourceMappingURL=demo-specific.js.map
